module.exports = __webpack_public_path__ + "static/Meicai-7a107dc5b915aae5a6269382a50552b4.jpg";